export const DetailMenus = [
  {
    id: 'thong_tin_chung',
    label: 'Thông tin chung',
    icon: 'person-lines-fill',
    link: '/customer-support/store/{id}',
  },
  {
    id: 'lich_su_gan',
    label: 'Lịch sử gán NV',
    icon: 'list-check',
    link: '/customer-support/store/{id}/history-assign',
  },
  {
    id: 'lich_su_go_gan',
    label: 'Lịch sử gỡ gán NV',
    icon: 'list-check',
    link: '/customer-support/store/{id}/history-remove-assign',
  },
  {
    id: 'list_contact',
    label: 'Lịch sử chăm sóc',
    icon: 'phone',
    link: '/customer-support/task/?storeId={maId}&storeName={maName}',
  },
  {
    id: 'list_history_rename',
    label: 'Lịch sử cập nhật thông tin cửa hàng',
    icon: 'list-check',
    link: '/customer-support/store/{id}/history-rename',
  },
  {
    id: 'list_device',
    label: 'Trạng thái sử dụng thiết bị',
    icon: 'list-check',
    link: '/customer-support/device-store/?storeId={maId}&storeName={maName}',
  },
]

export const asignType = {
  CVKD: 'CVKD',
  AS_ONLINE: 'AS Online',
  AS_OFFLINE: 'AS Offline',
  MANAGER_ASSIGNED: 'Cấp quản lý được giao chăm sóc',
  OTHER: 'Khác',
}
